import { Array, Number, Optional, Record, String, Unknown } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type TextSliderObject = {
  uuid?: string
  des: string
  obs: string
  complement?: string
}

export type TextSliderProps = {
  props: {
    objects: TextSliderObject[]
    color?: string
    initial_slider?: number
    right_arrow_color?: string
    left_arrow_color?: string
    styleMap?: StyleMap
  } & React.HTMLAttributes<HTMLDivElement>
}

export const TextSliderTypeGuard = Record({
  objects: Array(
    Record({
      uuid: Optional(String),
      obs: String,
      des: String,
      complement: Optional(String)
    })
  ),
  color: Optional(String),
  right_arrow_color: Optional(String),
  left_arrow_color: Optional(String),
  initial_slider: Optional(Number),
  styleMap: Optional(Unknown)
})
